import clsx from "clsx";
import React from "react";
import styles from "./styles/NotificationFooter.module.css";
import LogoSVG from "@assets/svgs/logo1.svg";
import { Container } from "react-bootstrap";

const NotificationFooter = () => {
  return (
    <div className={styles.footerWrapper}>
      <Container>
        <div className={clsx("py-4 m-0", styles.contentContainer)}>
          <div className="p-0 d-flex align-items-center">
            <img src={LogoSVG} alt="logo" className={styles.logoFooter} />
            <p className="m-0">
              © 2022 <strong>Cursus</strong>. All Rights Reserved.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

/* required: display name */
NotificationFooter.displayName = "NotificationFooter";

/* required: props types */
NotificationFooter.propTypes = {};

/* required: default props */
NotificationFooter.defaultProps = {};

export { NotificationFooter };
